export default __webpack_public_path__ + "static/media/upload.fef9af39.svg";